/*
 * @Author: mrzou
 * @Date: 2021-03-18 10:22:52
 * @LastEditors: pengchunyan
 * @LastEditTime: 2023-08-02 12:25:57
 * @Description: file content
 */
import Vuex from 'vuex'
import TYPE from './mutation-types'
import integration from './modules/integration'
import mall from './modules/mall'
import userInfo from './userInfo/index'
const createStore = () => {
  return new Vuex.Store({
    state: () => ({
      showShare: true,
      appVersion: '',
      doctorId: ''
    }),
    mutations: {
      [TYPE.SET_TOGGLE_SHARE](state, payload) {
        state.showShare = payload
      },
      updateAppVersion(state, payload) {
        state.appVersion = payload
      },
      getLocalStorageDoctorId(state, payload) {
        state.doctorId = payload
      }
    },
    modules: {
      integration,
      userInfo,
      mall
    }
  })
}

export default createStore
